import { RouteConfig } from 'vue-router';
import Form from './views/Form.vue';
import List from './views/List.vue';

export default [
  // list
  {
    name: 'vatconfiguration',
    path: '',
    component: List,
  },
  // edit
  {
    path: ':id(new|\\d+)',
    component: Form,
    meta: {
      hideMenu: true,
      hideTab: true,
    },
  },
] as RouteConfig[];
